<div
    class="chart-container"
    #chartTarget
    [ngClass]="{ 'd-none': !hasData }"
></div>
